import { NgModule } from '@angular/core';
import { CpfMaskDirectiveModule } from './cpf/cpf-mask.module';
import { CpfCnpjDirectiveModule } from './cpf-cnpj/cpf-cnpj-mask.module';
import { DateMaskDirectiveModule } from './date/date-mask.module';
import { DocMaskDirectiveModule } from './doc/doc-mask.module';
import { MaskInputDirectiveModule } from './mask/mask-input.module';
import { TelefoneMaskDirectiveModule } from './tel/telefone-mask.module';

@NgModule({
    imports: [
        CpfMaskDirectiveModule,
        CpfCnpjDirectiveModule,
        DateMaskDirectiveModule,
        DocMaskDirectiveModule,
        MaskInputDirectiveModule,
        TelefoneMaskDirectiveModule,
    ],
    exports: [
        CpfMaskDirectiveModule,
        CpfCnpjDirectiveModule,
        DateMaskDirectiveModule,
        DocMaskDirectiveModule,
        MaskInputDirectiveModule,
        TelefoneMaskDirectiveModule,
    ],
})
export class MasksDirectivesModule {}
